var text_field_default = {
  "root": "nkQJ-",
  "text": "mFEYC",
  "input": "pOyC-",
  "small": "rpAbs",
  "medium": "fz3BE",
  "large": "rm6KW",
  "webview": "VFeuD",
  "endAdornment": "MANEp",
  "shown": "jYt4a",
  "value": "f0HIb",
  "spinner": "rlC1Z",
  "spin": "bvQM8"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
